import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getApiAction, getSiteId } from "../../Utils/helper";
import SupportPopup from "../SupportPopup/SupportPopup";
import { productCartCount } from "../../store/action";

const Header = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1); // Navigate back by one step
  };
  const cartCountDetect = useSelector((state) => state.main.cartCount);
  const dispatch = useDispatch();

  const [cartCount, setCartCount] = useState(0);
  const [showSupport, setShowSupport] = useState(false);

  useEffect(() => {
    return async () => {
      setTimeout(async () => {
        if(localStorage.getItem('booking_reference_id') !== null){
          let cartCountData = await getApiAction('cart/count', {}, 0, dispatch);
          dispatch(productCartCount(cartCountData?.count))
          setCartCount(cartCountData?.count)
        }
      }, 300);

    }
  },[cartCountDetect])

  const closePopup = () => {
    setShowSupport(false);
  };

  return (
    <div>
      {showSupport && <SupportPopup closePopup={closePopup}/>}
      
      <header className="headerSite">
        <div className="container">
          <div className="headerBox d-flex flex-wrap justify-content-between align-items-center">
            <div className="hdr_left">
              <button className="arrow_icon" onClick={goBack}>
                <img src={`${BASE_URL}/assets/images/arrow_left.png`} alt="" />
              </button>
              {location.pathname != "/category-menu" && (
                <Link to={`/${getSiteId()}/category-menu`} className="arrow_icon">
                  <img src={`${BASE_URL}/assets/images/home.png`} alt="" />
                </Link>
              )}
              <button className="help_icon help-btn" onClick={() => setShowSupport(true)}>
                <img src={`${BASE_URL}/assets/images/help.png`} alt="" />
              </button>
            </div>
            <div className="middle_logo">
              <a href="#">
                <img src={`${BASE_URL}/assets/images/logo.png`} alt="" />
              </a>
            </div>
            <div className="hdr_right">
              <Link to={`/${getSiteId()}/cart`} className="orderBox">
                <span className="number">
                  <strong>
                    {cartCount}
                  </strong>{" "}
                  <img src={`${BASE_URL}/assets/images/order.png`} alt="" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
